import { render, staticRenderFns } from "./classesManageList.vue?vue&type=template&id=81aee56e&scoped=true"
import script from "./classesManageList.vue?vue&type=script&lang=js"
export * from "./classesManageList.vue?vue&type=script&lang=js"
import style0 from "./classesManageList.vue?vue&type=style&index=0&id=81aee56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aee56e",
  null
  
)

export default component.exports